import React from "react";
import TdsatSuccessIcon from '../../images/tdsatSuccess.svg';
import { Typography, Grid, Box, Button } from "@material-ui/core";
import validateDateAndFormat from "utils/validateDateAndFormat";

const SuccessScreenTdsat = ({diaryNumber, date, isApplicationRedirection = false, setSelected}) => {
    const handleApplicationPage =() => {
        setSelected(6);
    }
    return(
        <Box sx={{ flexGrow: 1 }}>
           <img src={TdsatSuccessIcon}/>
           <Grid justify="center" container style={{marginTop: '60px', marginBottom: '10px'}}>
                {diaryNumber && (
                    <>
                        <Typography variant="h1">Diary Number:&nbsp;</Typography>
                        <Typography variant="h1">{diaryNumber}</Typography>
                    </>
                )}
           </Grid>
           <Grid justify="center" container>
                <Typography variant="h1">Date & Time:&nbsp;</Typography>
                <Typography variant="h1">{validateDateAndFormat(date, "dd/MM/y | h:mm a")}</Typography>
           </Grid>
           <Typography style={{marginTop:'30px', fontSize: '16px', color: '#4B4E56'}}>Please note this diary number for future reference.</Typography>
            {isApplicationRedirection ? (
            <Typography style={{ marginTop: '30px', fontSize: '20px', color: '#333', fontWeight: 600 }}>
                Whether any Application is to be submitted with the Main Case? &nbsp;
                <Button 
                variant="text" 
                onClick={handleApplicationPage} 
                style={{color: 'white', backgroundColor: '#4A3BFF', textTransform: 'none', fontWeight: 600, padding: 8, minWidth: 'auto' }}
                >
                Click Here
                </Button>
            </Typography>
            ) : null}        
        </Box>
    )
}

export default SuccessScreenTdsat